import { prepGallerySizes } from 'components/_shared/widgets/gallery';
import {
  isSimpleGalley,
  ListingItem,
  ListingTypeEnum,
} from 'components/_shared/widgets/product-listing/types';
import { CATEGORIES_DEFAULT, CATEGORY_ALL } from './constants';
import {
  ProductInterface,
  QueryPermanentShopPageOutput,
  SimpleGalleryInterface,
} from 'types/types';
import { chunkArray } from '../../../util/arrays';
import mem from 'mem';
import { GiftVouchersPage } from 'components/_pages/gift-vouchers/types';

const PAGE_LENGTH = 12;

export const setLayout = (products: SimpleGalleryInterface[]) => {
  const items: ListingItem[] = [];
  const chunkedProductsList = chunkArray(products, PAGE_LENGTH);

  chunkedProductsList.map(group => {
    items.push({
      type: ListingTypeEnum.SimpleGallery,
      props: {
        items: group,
        layout: prepGallerySizes(group.length, [
          [2, 2, 2, 2, 2, 2],
          [3, 3, 3, 3],
          [4, 4, 4],
        ]),
      },
    });
  });

  return items;
};

export const prepVouchersData = (products: ProductInterface[]) => {
  const voucherPageProductsList: SimpleGalleryInterface[] = [];

  products.map(product => {
    const voucherPageProduct: SimpleGalleryInterface = {
      id: product.id,
      image: product.image,
      position: product.position,
      shop: product.shop,
      _galleryType: 'simple',
    };

    voucherPageProductsList.push(voucherPageProduct);
  });

  return setLayout(voucherPageProductsList);
};

export const createCategoriesList = (products: ProductInterface[]) => {
  const categories = [...CATEGORIES_DEFAULT];

  products.map(product => {
    if (product.shop?.name && !categories.includes(product.shop.name)) {
      categories.push(product.shop.name);
    }
  });

  return categories;
};

export const giftVoucherPageProps: (
  data: QueryPermanentShopPageOutput
) => GiftVouchersPage = ({ permanentShopProducts }) => ({
  items: prepVouchersData(permanentShopProducts),
  categories: createCategoriesList(permanentShopProducts),
});

export const filterProducts = mem(
  ({
    selectedCategory,
    giftVouchersProps,
  }: {
    selectedCategory: string;
    giftVouchersProps: ListingItem[];
  }) => {
    let filteredProducts: ListingItem[];

    if (selectedCategory === CATEGORY_ALL) {
      filteredProducts = giftVouchersProps;
    } else {
      const newProducts: SimpleGalleryInterface[] = [];
      giftVouchersProps.forEach(gallery => {
        if (isSimpleGalley(gallery)) {
          gallery.props.items.filter((item: SimpleGalleryInterface) => {
            if (item.shop?.name === selectedCategory) {
              newProducts.push(item);
            }
          });
        }
      });

      filteredProducts = setLayout(newProducts);
    }

    return filteredProducts;
  }
);
